import { render, staticRenderFns } from "./modalEducacionesList.vue?vue&type=template&id=0121bfc6"
import script from "./modalEducacionesList.vue?vue&type=script&lang=js"
export * from "./modalEducacionesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports